document.querySelectorAll('.model-embed-button').forEach(function(button) {
  button.addEventListener('click', function() {
    const parent = this.closest('.model-embed-wrapper');
    const modelHolder = parent.querySelector('.model-embed-holder');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modelEmbedIframe.trim();
    const iframe = tempDiv.firstElementChild;
    const src = iframe.getAttribute('src');
    iframe.setAttribute('src', '');
    modelHolder.appendChild(iframe);
    setTimeout(function() {
      parent.querySelector('iframe').setAttribute('src', src);
    }, 100);
    parent.classList.add('model-loaded');
  });
});
